import React, { useState } from 'react';
import clsx from 'clsx';
import './index.css';
interface AccordionProps {
 title: string;
 children?: React.ReactNode;
 className?: string;
}

const Accordion: React.FC<AccordionProps> = ({ title, children, className }) => {
 const [open, setOpen] = useState(true);
 return (
    <div className={clsx('lb-accordian', { 'open': open }, className )}>
      <div className="tw-flex tw-justify-between tw-items-center tw-py-2 tw-cursor-pointer" onClick={() => {setOpen(!open)}}>
        <div className="accordian-title">{title}</div>
        <svg className={`tw-h-1.5 tw-w-2.5 tw-text-primary-color tw-transform ${open ? 'tw-rotate-180' : ''}`} viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <div className='accordian-content'>
        {children}
      </div>
    </div>
 );
};
export default Accordion;

//tw-transition-all tw-ease-in-out tw-duration-1000